import { Button as ThemeUiButton } from "theme-ui";

import { ChevronRightIcon } from "components/icons";
import * as styles from "./HelpButton.styles";

export default function HelpButton({ children, ...props }) {
  return (
    <ThemeUiButton variant="unstyled" sx={styles.helpButton} {...props}>
      {children}
      <ChevronRightIcon />
    </ThemeUiButton>
  );
}
